module.exports = __webpack_public_path__ + "static/media/arrow-long.2d0fd08c.svg";